import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { EntitiesStore } from './entities-store.abstract';
import { MembersAssociationsStatsStore } from './members-associations-stats-store';

export interface IMemberAssociations {
  MaId: number;
  MaName: string;
  NOC: string;
  CName: string;
  CShort: string;
  MaStatusCode: number;
  MaStatus: string;
  CaId: number;
  CaCode: string;
  CaName: string;
  Continent: string;
}

export default class MemberAssociationsStore extends EntitiesStore<IMemberAssociations> {
  constructor(http: HttpClient) {
    super('MEMBERASSOCIATIONS', http,  [{entity: new MembersAssociationsStatsStore(http, [])}]);
  }
}
